import {Component, OnDestroy, OnInit, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent} from '@angular/material';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import * as toastr from 'toastr';
import {MinimumCommService} from './service-minimum-comm/minimum-comm.service';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {MinimumCommModel} from '../../../models/MinimumCommModel';
import { Router } from '@angular/router';
import {ProviderModel} from '../../../models/ProviderModel';
import {UsersService} from '../../users/service/users.service';

@Component({
  selector: 'app-minimum-comm',
  templateUrl: './minimum-comm.component.html',
  styleUrls: ['./minimum-comm.component.scss']
})
export class MinimumCommComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: MinimumCommModel[];
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  offset: Offset;
  getFirstProviderObservable: Observable<any>;
  isMinimunSection: boolean;
  selectedRowIndex: number;

  filter: MinimumCommModel;
  showNewEditDelete: boolean;
  showFilter: boolean;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() idSelected?: number;
  @Input() showActions?: boolean;
  @Input() reportSection?: boolean;

  @Output() elementSelected = new EventEmitter();


  constructor(private minimumCommitmentService: MinimumCommService,
              private userService: UsersService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.loaderService.display(true);
    this.showActions = true;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.sectionId = this.SECTIONS.CONTRACTUAL_DATA;
  }

  ngOnInit() {
    this.isMinimunSection = this.returnIsContractSection(this.router.url);
    this.showNewEditDelete = !this.checkRole();
    this.showFilter = false;
    this.selectedRowIndex = this.idSelected;

    this.displayedColumns = ['provider', 'Year', 'Value', 'actions'];

    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.MINIMUM_COMMTIMENT_OFFSET);
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });

    this.getSessionStorageFilter();

    if (!this.reportSection) {
      this.showFilter = false;
      this.getDataPage(this.offset, this.filter);
    } else {
      this.showFilter = true;
    }
    this.loaderService.display(false);
  }

  getDataPage(offset: Offset, filter: MinimumCommModel) {
    this.getPageSubscribe = this.minimumCommitmentService.getPage(offset, filter)
      .subscribe(
        (result: any) => {
          this.dataSource = result.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = result.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const minimumComm = this.dataSource.find(data => data.id === id);
    const list: GenericArray[] = [
      {id: 'Year', value: this.toCustomString(minimumComm.anno.toString())},
      {id: 'Value', value: this.toCustomString(minimumComm.value.toString())},
      {id: 'Provider', value: this.toCustomString(minimumComm.provider.description)}
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      hasBackdrop: true,
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.MINIMUM_COMMTIMENT_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);

  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.minimumCommitmentService.softDelete(id)
        .subscribe(
          (result: any) => {
            toastr.success('Minimum Commitment with id ' + id + ' was deleted with success', 'Success');
            this.getDataPage(this.offset, this.filter);
          }, error =>  {
            toastr.error('Minimum Commitment with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(5, 0);
    }
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }
    this.loaderService.display(false);  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }  }

  showNewMassive() {
    let showNewMassive = false;
    if (this.canInsert) {
      showNewMassive = true;
    }
    if (this.reportSection) {
      showNewMassive = false;
    }
    return showNewMassive;
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.MINIMUM_COMMITMENT_FILTER));
    this.filter = filter_ ? filter_ : new MinimumCommModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
  }

}
